import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";
import NoDataFound from "components/NoDataFound";
import { handleError } from "utils";
import { showSuccess } from "services/toast.service";
import RemoveButton from "components/Button/RemoveButton";
import Loader from "components/Loader";
import UpdateButton from "components/Button/UpdateButton";
import { API_BASE_URL } from "config/constants";
import { getAccessToken } from "utils";
import { getUser } from "utils";
import { InvoiceTemplateModal } from "./InvoiceTemplateModal";

export default function Invoices({ color }) {
  const data = [];
  const history = useHistory();
  const [invoice, setInvoice] = useState(data);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(0);
  const [gettingData, setGettingData] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);

  const handleSetInvoiceModal = (isOpen = false) => () => {
    setIsInvoiceModalOpen(isOpen);
  }

  const user = getUser();

  const getInvoice = async () => {
    try {
      setGettingData(true);

      const responce = await axios.get(`${API_BASE_URL}/invoice`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: getAccessToken(),
        },
      });

      setGettingData(false);
      const apiData = responce.data;
      setInvoice(apiData.result.data.result);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };

  useEffect(() => {
    getInvoice();
  }, []);

  ///Delete

  const DeleteInvoice = async (id) => {
    try {
      setSelectedInvoiceId(id);
      setDeleteLoading(true);
      const deleteResponse = await axios.delete(`${API_BASE_URL}/invoice`, {
        headers: {
          "Content-Type": "application/json",
          authorization: getAccessToken(),
        },
        data: {
          id: id,
        },
      });

      setSelectedInvoiceId(0);
      setDeleteLoading(false);
      showSuccess(deleteResponse?.data?.result?.message);
      getInvoice();
    } catch (error) {
      setSelectedInvoiceId(0);
      setDeleteLoading(false);
      handleError(error);
    }
  };

  const goToUpdateData = (data) => {
    history.push("/admin/update-invoice", {
      data,
    });
  };

  const filterData = (data) => {
    if (!keyword) return true;
    if (
      data.accountName.toLowerCase().includes(keyword.toLowerCase()) ||
      data.description.toLowerCase().includes(keyword.toLowerCase())
    ) {
      return true;
    }
    return false;
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
  };
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative flex justify-items-start gap-2 items-center w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                All Invoices
              </h3>
              <Loader loading={gettingData} />
            </div>
            <Link to="/admin/add-invoice">
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="button"
              >
                Add New Invoice
              </button>
            </Link>
          </div>
        </div>

        <div className="flex px-4 pb-3">
          <input
            type="text"
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full lg:w-1/3 ease-linear transition-all duration-150"
            placeholder="Search.."
            name="clicks"
            value={keyword}
            onChange={handleKeywordChange}
          />
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Client Name
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Description
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Period
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Amount
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Payment Status
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Created On
                </th>

                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Updated On
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {invoice[0] ? (
                <>
                  {invoice.filter(filterData).map((inv) => {
                    return (
                      <tr>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {inv.accountName}
                        </td>
                        <td className="border-t-0 px-6 alig n-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {inv.description}
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          {inv.period}
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">{inv.amount} USD</span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">{inv.status}</span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {moment(inv.createdAt).format("llll")}
                            </span>
                          </div>
                        </td>

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            <span className="mr-2">
                              {moment(inv.updatedAt).format("llll")}
                            </span>
                          </div>
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">

                          {/* <button onClick={handleSetInvoiceModal(true)} className="fas fa-download mr-2 text-sm  bg-green-500 text-white  active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">
                            {" "}
                          </button> */}

                            <UpdateButton onClick={() => goToUpdateData(inv)} />

                            {user.role === "Admin" && (
                              <RemoveButton
                                onClick={() => DeleteInvoice(inv._id)}
                                loading={
                                  deleteLoading && selectedInvoiceId === inv._id
                                }
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </>
              ) : (
                <td colSpan={13}>
                  <NoDataFound />
                </td>
              )}
            </tbody>
          </table>
        </div>
        <InvoiceTemplateModal open={isInvoiceModalOpen} onClose={handleSetInvoiceModal(false)} />
      </div>
    </>
  );
}
